module.exports = __webpack_public_path__ + "img/1.12e1c6a8.png";